import { Icon, IconNames } from "@atoms";
import React from "react";

interface WorkdayCollapsibleTileHandleProps extends React.PropsWithChildren {
  isOpen: boolean;
  icon: IconNames;
  className?: string;
  disabled?: boolean;
  onClick: () => void;
  /**
   * Simply sets the chevron position
   * - 90deg when the button clicks through to other screens
   * - 270deg when the button toggles content
   */
  isToggleable?: boolean;
}

export const WorkdayCollapsibleTileHandle = ({
  children,
  icon,
  className,
  isOpen,
  isToggleable = true,
  disabled = false,
  onClick,
}: WorkdayCollapsibleTileHandleProps) => {
  return (
    <button
      type="button"
      className={`flex flex-row items-center gap-6 py-5 px-5 min-h-[72px] w-full ${disabled ? "cursor-default" : ""} ${
        className || ""
      }`}
      onClick={!disabled ? onClick : undefined}>
      <Icon
        icon={icon}
        size="1.5rem"
        className="flex-shrink-0"
      />

      {children}

      {!disabled && (
        <Icon
          icon="caretRight"
          size="1.3rem"
          className={`ml-auto flex-shrink-0 ${
            isOpen ? (isToggleable ? "rotate-[270deg]" : "rotate-90") : isToggleable ? "rotate-90" : "rotate-0"
          }`}
        />
      )}
    </button>
  );
};
